module.exports = __webpack_public_path__ + "static/energy_private_5-107bf8b5d85988c5e8d4a7f9b85e94dc.jpg";